import {
  CouncilTwoToneIcon,
  DocumentTwoToneIcon,
  HomeTwoToneIcon,
  type IconProps,
  InboxTwoToneIcon,
  PlanningTwoToneIcon,
  PrivateTwoToneIcon,
  ProviderTwoToneIcon,
  TopicTwoToneIcon,
} from '@all-manager/design-system-v2';
import type { ComponentType } from 'react';
import type { Permissions } from '../../hooks/usePermissions';

export type NavigationDestinationId =
  | 'home'
  | 'calendar'
  | 'meetings'
  | 'inbox'
  | 'topics'
  | 'providers'
  | 'documents'
  | 'private-notes';

export type NavigationDestination = {
  id: NavigationDestinationId;
  label: string;
  /** Appended to the space path; empty for the space home. */
  subPath: string;
  Icon: ComponentType<IconProps>;
  /** Shown only to members holding this right; every member sees the others. */
  permission?: keyof Pick<Permissions, 'canSeeInbox' | 'canSeePrivateNotes'>;
};

export function isDestinationVisible(destination: NavigationDestination, permissions: Permissions) {
  return !destination.permission || permissions[destination.permission];
}

/** Sidebar work groups, shared with the onboarding preview so both show the same menu. */
export const NAVIGATION_GROUPS: { title: string; destinations: NavigationDestination[] }[] = [
  {
    title: 'Suivi',
    destinations: [
      { id: 'home', label: 'Sujets en cours', subPath: '', Icon: HomeTwoToneIcon },
      { id: 'calendar', label: 'Calendrier', subPath: '/calendar', Icon: PlanningTwoToneIcon },
      { id: 'meetings', label: 'Réunions', subPath: '/council/meetings', Icon: CouncilTwoToneIcon },
      { id: 'inbox', label: 'Boîte de réception', subPath: '/inbox', Icon: InboxTwoToneIcon, permission: 'canSeeInbox' },
    ],
  },
  {
    title: 'Référentiel',
    destinations: [
      { id: 'topics', label: 'Tous les sujets', subPath: '/topics-management', Icon: TopicTwoToneIcon },
      { id: 'providers', label: 'Prestataires', subPath: '/providers', Icon: ProviderTwoToneIcon },
      { id: 'documents', label: 'Documents', subPath: '/documents', Icon: DocumentTwoToneIcon },
      { id: 'private-notes', label: 'Notes privées', subPath: '/private-notes', Icon: PrivateTwoToneIcon, permission: 'canSeePrivateNotes' },
    ],
  },
];
